module.exports = __webpack_public_path__ + "static/media/refresh-black-24dp.2493b8d8.svg";